import { render } from "./editinvoice.vue?vue&type=template&id=fbc74344&scoped=true"
import script from "./editinvoice.vue?vue&type=script&lang=js"
export * from "./editinvoice.vue?vue&type=script&lang=js"

import "./editinvoice.vue?vue&type=style&index=0&id=fbc74344&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc74344"]])

export default __exports__